import { getAllUsersHospitalInfo, getAllUsersInfo } from '../api/hospitalsAPI';
import NewUser from '../components/forms/NewUser';
import UserTable from '../components/hospitalDashboard/UserTable';
import DashboardHeader from '../components/mainDashboard/DashboardHeader';
import Button from "../components/ui/Button";
import Loader from '../components/ui/Loader';
import WrapperModal from "../components/ui/WrapperModal";
import { AccessibilityContext } from "../store/accesibility-context";
import AuthContext from "../store/auth-context";
import { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import './PIDashboard.scss';
import ConfirmationWarning from '../components/ui/ConfirmationWarning';


const DashboardUsers = () => {
    const [hospitalId, setHospitalId] = useState('')
    const [role, setRole] = useState() 
    const userHospitalList = useQuery({
        queryKey: ['user-hospital', hospitalId, role], 
        queryFn: () => getAllUsersHospitalInfo({ hospitalId, role }), 
        retry: false,
        staleTime: 3000000, // 5 minutos antes de refetch
    });

    const authCtx = useContext(AuthContext);
	const accessibilityCtx = useContext(AccessibilityContext);
    const [addNewUser, setAddNewUser] = useState(false);
    const [userCreated, setUserCreated] = useState(false)

    useEffect(() => {
        if (authCtx.userData?.hospital) {
          setHospitalId(authCtx.userData.hospital);
        }
      }, [authCtx.userData.hospital]);

    const newUserHandler = () => {
        setAddNewUser(true);
    }
    
    const cancelStudyCreationHandler = () => {
        setAddNewUser(false);
    };
	
    if(userHospitalList.isLoading || !hospitalId){   
        return <Loader/>
    }
	return (
		<div className='dashboard-general-wrapper'>
			<DashboardHeader />
            <div className='dashboard-content-container'>
                <div className='content-header'>
                        <div className='content-title'>
                            <h2>Users</h2>
                        </div>
                    <div className='content-controls'>
                        <div className='button-controler'>
                        <Button
                            onClick={() => newUserHandler(false)}
                            className={`${
                                accessibilityCtx.contrast === false
                                ? 'primary-button'
                                : 'primary-button-contrast'
                            } create-study-buttons new-user-btn`}
                            startIcon='add'
                            >
                            New User
                        </Button>
                        </div>
                    </div>
                </div>
                <div className='table'>
                    <UserTable data={userHospitalList.data.data.doctors}/>
                </div>
            </div>
            {addNewUser && (
            <WrapperModal
                onDismiss={cancelStudyCreationHandler}
            >
                <NewUser
                  onAccept={()=>{
                    setAddNewUser(false);
                    setUserCreated(true)
                  }}
                ></NewUser>
            </WrapperModal>
            )}
            {userCreated && (
            <WrapperModal
                onDismiss={cancelStudyCreationHandler}
            >
                <ConfirmationWarning
                title={'A new user was created'}
                acceptLabel={'Continue'}
                declineLabel={'Close'}
                onAccept={()=>{setUserCreated(false)}}
                onDecline={()=>{setUserCreated(false)}}
                            >
                </ConfirmationWarning>
            </WrapperModal>
            )}
		</div>
	);
};
export default DashboardUsers;